import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=4c8b49cc&"
import script from "./PhoneInputVue.ts?vue&type=script&lang=ts&"
export * from "./PhoneInputVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports